import CONCESSION_REQUESTS from "@/services/admin/concessionRequest";

export default [
  {
    divider: "Administrador",
    children: [
      {
        title: "Membros",
        icon: "mdi-account-group",
        to: "admin.members",
        permission: 2,
      },
      {
        title: "Técnicos",
        icon: "mdi-account-wrench",
        to: "admin.technicians",
        permission: 2,
      },
      {
        title: "Chaves de API",
        icon: "mdi-key",
        to: "admin.api-keys",
        permission: 2097152,
      },
    ],
  },
  {
    divider: "Gerenciar",
    children: [
      {
        title: "Plataformas",
        icon: "mdi-web",
        to: "admin.platforms",
        permission: [256, 512],
      },
      {
        title: "Organizações",
        icon: "mdi-domain",
        to: "admin.organizations",
        permission: [1024, 2048],
      },
      {
        title: "Eventos",
        icon: "mdi-party-popper",
        to: "admin.parties",
        permission: 4096,
      },
      {
        title: "Mensageria",
        icon: "mdi-message",
        to: "admin.messager",
        permission: [8192],
      },
      {
        title: "Campanhas",
        icon: "mdi-bullhorn",
        to: "admin.campaigns",
        permission: [8192],
      },
      {
        title: "Cadastros",
        icon: "mdi-account-plus",
        to: "admin.registrations",
        permission: [1048576],
      },
      {
        title: "Solicitações Meia Entrada",
        icon: "mdi-ticket-percent",
        to: "admin.concession-request",
        permission: [8388608, 16777216],
        badge: {
          refreshEvent: "refreshConcessionRequests",
          handler: async (data) => {
            try {
              const response = await CONCESSION_REQUESTS.getCount();
              return response.count;
            } catch (error) {
              console.error(error);
              return false;
            }
          }
        }
      },
      {
        title: "Solicitação de Recurso",
        icon: "mdi-message",
        to: "admin.resource-request",
        permission: [8388608, 16777216],
      },
    ],
  },
  {
    divider: "Financeiro",
    children: [
      {
        title: "Taxas",
        icon: "mdi-percent",
        to: "admin.fees",
        permission: [262144, 524288],
      },
      {
        title: "Relatórios",
        icon: "mdi-chart-bar",
        to: "admin.financial.reports",
        permission: 16,
      },
      {
        title: "Transações",
        icon: "mdi-cash",
        to: "admin.financial.transations",
        permission: 131072,
      },
      // {
      //   title: "Reembolsos",
      //   icon: "mdi-cash-refund",
      //   to: "admin.financial.refunds",
      //   permission: 64,
      // },
    ],
  },

  // {
  //   divider: "Estoque",
  //   children: [
  //     {
  //       title: "Inventario",
  //       icon: "mdi-store",
  //       to: "admin.users",
  //       permission: 8,
  //     },
  //     {
  //       title: "Produtos",
  //       icon: "mdi-store",
  //       to: "admin.users",
  //       permission: 8,
  //     },
  //   ],
  // },
  // {
  //   divider: "Comercial",
  //   children: [
  //     {
  //       title: "Leads",
  //       icon: "mdi-account",
  //       to: "admin.users",
  //       permission: 8,
  //     },
  //     {
  //       title: "Contratos",
  //       icon: "mdi-paperclip",
  //       to: "admin.users",
  //       permission: 8,
  //     },
  //   ],
  // },
  // {
  //   divider: "Comercial",
  //   children: [
  //     {
  //       title: "Leads",
  //       icon: "mdi-account",
  //       to: "admin.users",
  //       permission: 8,
  //     },
  //     {
  //       title: "Contratos",
  //       icon: "mdi-paperclip",
  //       to: "admin.users",
  //       permission: 8,
  //     },
  //   ],
  // },
];
